import { isValidPhoneNumber } from "libphonenumber-js";

export const PHONE_VALIDATION_MESSAGE = "Please enter a valid phone number.";

export function getPhoneValidationError(
  value,
  { required = true, requiredMessage = "Phone number is required." } = {},
) {
  const normalized = value?.trim?.() ?? "";

  if (!normalized) {
    return required ? requiredMessage : "";
  }

  if (!isValidPhoneNumber(normalized)) {
    return PHONE_VALIDATION_MESSAGE;
  }

  return "";
}

export function isPhoneNumberValid(value) {
  return Boolean(value && isValidPhoneNumber(value));
}
